<template>
    <div class="dataConsultGov">
        <dataConsult type="gov"></dataConsult>
    </div>
</template>

<script>
    import dataConsult from "./dataConsult.vue";

    export default {
        name: "dataConsultGov",
        components: {
            dataConsult
        },
        props: {},
        data () {
            return {};
        },
        computed: {},
        created () {},
        methods: {}
    };
</script>



// WEBPACK FOOTER //
// src/views/introduction/dataConsult/dataConsultGov.vue